(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDetailController', CustomGroupTypeAttributeDetailController);

    CustomGroupTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customGroupTypeAttributeUpdate', function(event, result) {
            vm.customGroupTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
